export const nl_NL = {
  translation: {
    add_to_cart: "Artikel aan winkelwagen toevoegen",
    save: "Opslaan",
    load: "Artikel laden",
    title: "Configuratie",
    type_key: "Typesleutel",
    start: "Start",
    generate_document: "Datasheet maken",
    sap_button: "Artikel in SAP aanmaken",
    cad_button: "CAD-gegevens maken",
    reset_configuration: "Configuratie resetten",
    show_additional_information: "Extra informatie tonen",
    sap_title: "SAP",
    close_configuration_button: "Sluiten",
    no_results_found: "Geen resultaten gevonden",
    load_configuration_dialog: {
      title: "Configuratie laden – Zoekparameters instellen",
      cancel: "Annuleren",
      search: "Zoeken",
      start_date: "Aanmaakdatum van",
      end_date: "tot",
      guid: "GUID",
      material_number: "Materiaalnummer",
      order_code: "Bestelcode",
      creator: "Maker",
      description: "Beschrijving",
      info_artikel: "Info-artikel",
      short_text: "Korte tekst",
      version: "Versie",
      status: "Status",
      update_user: "Bijgewerkt door",
      createdDate: "Aanmaakdatum",
      saved_records: "Opgeslagen records",
      back: "Terug",
      open: "Openen",
      rows_per_page: "Rijen per pagina:",
    },
    error: {
      ERROR_LOAD_DATA_ERROR: "(LADEN) mislukt (gegevens onjuist of onvolledig)",
      ERROR_SAVE_DATA_ERROR:
        "(OPSLAAN) mislukt (gegevens onjuist of onvolledig)",
      ERROR_LOAD_ID: "ID om te laden niet gevonden",
      ERROR_LOAD_ID_CONFIG:
        "Fout van de configurator bij het laden van een project",
      ERROR_LOADSTART_CONFIG: "Fout van de configurator bij het starten",
      ERROR_MISSING_VALUES:
        "Algemene foutmelding als validatie van frontend-gegevens mislukt",
      ERROR_COOKIE_SERVICE_INITIAL: "Initialisatie van cookie-service mislukt",
      ERROR_COOKIE_GENERAL: "Fout in cookie-service",
      ERROR_TOKEN_NOT_FOUND: "Token niet gevonden",
      ERROR_ID_BLOCKED: "Artikel wordt bewerkt, wijzigingen niet mogelijk",
      ERROR_DB_SAVE: "Fout bij het opslaan van gegevens in de database",
      ERROR_LOAD_VALID: "Laden van configuratie mislukt, gegevens ongeldig",
      ERROR_NONE_LOAD_ID_FOUND_SAP_CHECK:
        "ID niet gevonden, SAP-controle mislukt",
      ERROR_NONE_LOAD_ID_FOUND_ROWID_FROM_SHOPID:
        "Geen materiaalnummer gevonden voor de ID uit de shop-ID",
      ERROR_DELETE_CONFIGURATION:
        "Fout bij het verwijderen van de configuratie",
      ERROR_DEFINITION_SECRET_JWT: "JWT-definitie ontbreekt",
      ERROR_PATH_NOT_DEFINED: "Pad niet gedefinieerd",
      ERROR_BACKLINK_URL: "Backlink-URL niet gedefinieerd",
      ERROR_POSITIONDATA_EMPTY: "Positiegegevens zijn leeg",
      ERROR_SHOP_ID: "Shop-ID niet gevonden",
      ERROR_CADBOXDATA_EMPTY: "Geen CAD box-gegevens gevonden",
      ERROR_NONE_LOAD_ID_FOUND: "Geen ID om te laden gevonden",
      ERROR_NONE_ACCEPTABLE_ID: "Geen acceptabele ID gevonden",
    },
    sap: {
      create_error: "Fout bij aanmaken",
      create_success: "Succesvol aangemaakt",
    },
    button: {
      save: "Opslaan",
      cancel: "Annuleren",
    },
  },
};

export default nl_NL;
